import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import * as utils from "@/lib/utils";
const { cn } = utils;
import { cva, VariantProps } from "class-variance-authority";

const progressVariants = cva("", {
  variants: {
    variant: {
      scheduled: "",
      starting: "",
      installing: "",
      deploying: "",
      pending: "",
      running: "",
      done: "",
      ready: "",
      completed: "",
      disabled: "",
      canceled: "",
      cancelled: "",
      cancelling: "",
      failed: "",
      aborted: "",
      suspended: "",
      stopped: "",
    },
  },
  defaultVariants: {},
});
const progressBarVariants = cva("", {
  variants: {
    variant: {
      scheduled: "bg-azure text-azure-foreground",
      starting: "bg-azure text-azure-foreground",
      installing: "bg-azure text-azure-foreground",
      deploying: "bg-azure text-azure-foreground",
      pending: "bg-azure text-azure-foreground",
      running: "bg-azure text-azure-foreground",
      done: "bg-success text-success-foreground",
      ready: "bg-success text-success-foreground",
      completed: "bg-success text-success-foreground",
      disabled: "",
      canceled: "bg-warning text-warning-foreground",
      cancelled: "bg-warning text-warning-foreground",
      cancelling: "bg-warning text-warning-foreground",
      failed: "bg-error text-error-foreground",
      aborted: "bg-error text-error-foreground",
      suspended: "bg-lavender text-lavender-foreground",
      stopped: "bg-lavender text-lavender-foreground",
    },
  },
  defaultVariants: {},
});
type Props = React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> &
  VariantProps<typeof progressVariants> &
  VariantProps<typeof progressBarVariants> & { indicatorClassName?: string };

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  Props
>(
  (
    {
      className,
      indicatorClassName,
      children,
      value,
      max: _max,
      variant,
      ...props
    },
    ref,
  ) => {
    const max = utils.max(value, _max ?? 100);
    return (
      <ProgressPrimitive.Root
        ref={ref}
        className={cn(
          "relative z-0 h-6 w-full overflow-hidden rounded-md bg-gray-200 border",
          progressVariants({ variant }),
          className,
        )}
        style={{
          transform: "translateZ(0)",
          ...{ "--min": 0, "--max": max, "--value": value },
        }}
        value={value}
        max={(max ?? 0) <= 0 ? undefined : max}
        {...props}
      >
        <ProgressPrimitive.Indicator
          className={cn(
            "h-full transition-all w-[calc((var(--value)-var(--min))/(var(--max)-var(--min))*100%)] px-1 min-w-fit",
            progressBarVariants({ variant }),
            indicatorClassName,
          )}
        >
          {/* {children && <span className="absolute left-1">{children}</span>} */}
          {children}
        </ProgressPrimitive.Indicator>
      </ProgressPrimitive.Root>
    );
  },
);

Progress.displayName = "Progress";

export { Progress };
